import accordion from '@salesforce/retail-react-app/app/theme/components/base/accordion'
accordion.baseStyle.button.color = 'black.100'
accordion.baseStyle.button.fontFamily = 'heading'
accordion.baseStyle.button._hover = {
    ...accordion.baseStyle.button._hover,
    textDecoration: 'none'
}

accordion.variants = {
    accordion: {
        container: {
            borderColor: 'gray.700'
        },
        button: {
            color: 'black',
            paddingY: '15px',
            fontSize: '23px',
            fontWeight: '500',
            fontFamily: 'caslon',
            lineHeight: 'normal',
            letterSpacing: '0.115px',
            justifyContent: 'space-between'
        },
        panel: {
            paddingX: 0,
            paddingTop: '0px',
            paddingBottom: '15px',
            color: 'black.100',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '300',
            lineHeight: '25px',
            letterSpacing: '0.08px'
        }
    }
}

export default accordion
